import React from 'react';
import NewarkDonorListItem from './NewarkDonorListItem';

export default props => {
  return (
    <li className="newark__donor-list-container">
      <h3 className="newark__donor-list-heading-3">{props.listHeading}</h3>
      <ul className="newark__donor-list">
        {
          props.donors.map((donor, i) => {
            return <NewarkDonorListItem donor={donor} key={'donor-list-item-' + i}/>;
          })
        }
      </ul>
    </li>
  );
};


// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkDonorList.js